import * as React from 'react';
import PlanProfileContainer from '../containers/PlanProfile/PlanProfileContainer';
import ToastContainer from '../containers/Notifications/ToastContainer';

const PlanProfile: React.FunctionComponent = () => (
	<React.Fragment>
		<ToastContainer />
		<PlanProfileContainer />
	</React.Fragment>
);

export default PlanProfile;
